import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { validURL } from 'utils/helpers';

export const _eventAllowedKeysRange = (event, allowedKeys) => {
  const isValidKey = event.charCode >= allowedKeys.min && event.charCode <= allowedKeys.max;

  return event.charCode === 8 || event.charCode === 0 ? null : isValidKey;
};

export class CertemyValidators {
  static emptyNumberFieldValidator(text = 'Please provide a number value.'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const { value } = control;

      if (!!value) {
        return null;
      }

      return { emptyNumber: text };
    };
  }

  static numberRangeValidator(min: number, max?: number) {
    return (control: AbstractControl): { errorNumberRange: { minBorder: boolean } | { maxBorder: boolean } } | null => {
      const { value } = control;

      if (!isFinite(+value)) {
        return null;
      }

      if (isFinite(min) && value < min) {
        return { errorNumberRange: { minBorder: true } };
      }

      if (isFinite(max) && value > max) {
        return { errorNumberRange: { maxBorder: true } };
      }

      return null;
    };
  }

  // Not a form validator. Event validator
  static numericFieldValidation(event) {
    const allowedKeys = {
      min: 48,
      max: 57,
      numMin: 96,
      numMax: 105,
    };
    return _eventAllowedKeysRange(event, allowedKeys);
  }

  static urlValidator(control: AbstractControl): ValidationErrors | null {
    const { value } = control;

    if (!value) {
      return null;
    }

    return validURL(value) ? null : { invalidUrl: true };
  }

  static realNumericFieldValidation(event) {
    const currentValueExists = !!event.currentTarget.value;

    const allowedKeys = {
      min: currentValueExists ? 48 : 49,
      max: 57,
      numMin: currentValueExists ? 96 : 97,
      numMax: 105,
    };
    return _eventAllowedKeysRange(event, allowedKeys);
  }
}
